import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../appSettings/appSetting'

const POWERBICONFIGGENERATOR_API = ShipbobAppSettings.powerBIConfigGeneratorUrl

export default class PowerBIService {

  static noop () {}

  static urls () {
    return {
      powerBIConfigGeneratorUrl: POWERBICONFIGGENERATOR_API + '/api/GetEmbedToken?ReportName='
    }
  }

  static async GetReport (reportName) {
    const request = {
      Url: this.urls().powerBIConfigGeneratorUrl + reportName
    }
    return await HttpWrapper.Get(request, null, null, true)
  }
}
